import { useEffect, useState } from "react";
import { GraduationCap } from "lucide-react";
import api from "@/lib/api";

const DEFAULTS = {
  eyebrow: "Compétences scientifiques",
  title: "Formation",
  banner_image: "/media/university-hall.jpg",
  intro:
    "L'Unité de Formation propose des programmes de formation continue, ateliers scientifiques et sessions de perfectionnement destinés aux enseignants-chercheurs, doctorants, bibliothécaires et personnel scientifique de l'UNISIC.",
  programs:
    "• Ateliers méthodologiques (rédaction, citation, gestion bibliographique)\n• Formation à la recherche documentaire\n• Perfectionnement en édition scientifique\n• Sessions annuelles sur les outils numériques de la recherche",
};

export default function Formation() {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/content/formation.home").then((r) => setContent({ ...DEFAULTS, ...(r.data || {}) })).catch(() => {});
  }, []);

  return (
    <div data-testid="formation-page">
      <section className="relative h-[42vh] min-h-[300px] overflow-hidden">
        <img src={content.banner_image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-veil" />
        <div className="relative h-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-14">
          <div className="eyebrow" style={{ color: "#E5C158" }}>{content.eyebrow}</div>
          <h1 className="mt-3 text-white text-4xl sm:text-5xl font-bold tracking-tight">{content.title}</h1>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-unisic-gold" />
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <div className="eyebrow eyebrow-dark">Objet</div>
            <span className="divider-gold mt-3" />
            <p className="mt-6 text-lg text-slate-700 leading-relaxed whitespace-pre-line">{content.intro}</p>
          </div>
          <aside className="paper-card p-6 h-fit">
            <div className="inline-flex items-center justify-center w-10 h-10 rounded-sm bg-unisic-blue text-white mb-3">
              <GraduationCap className="w-5 h-5" />
            </div>
            <div className="eyebrow eyebrow-dark">Programmes</div>
            <span className="divider-gold mt-2" />
            <p className="mt-4 text-sm text-slate-700 leading-relaxed whitespace-pre-line">{content.programs}</p>
          </aside>
        </div>
      </section>
    </div>
  );
}
